{
  "browserNotSupported": {
    "title": "Erro ao carregar o módulo",
    "text": "Para utilizar o módulo de acessórios, é necessário mudar para um browser atualizado."
  },
  "main": {
    "more": "Mais acessórios",
    "findMore": "Pode encontrar acessórios para reequipar/converter e atualizar o seu veículo aqui na nossa vasta oferta. Os acessórios que seleccionou serão enviados para o seu parceiro {{brand}} juntamente com o pedido do veículo.",
    "topOffers": "TOP Ofertas",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Produtos",
    "noArticleFound": "0 Produtos",
    "oemHint": "Seleccione já os acessórios correspondentes para o seu {{brand}}!",
    "noBrand": "Seleccione já os acessórios adequados para o seu veículo!",
    "outOfOrder": "Infelizmente, não existem produtos disponíveis de momento.<0/>Estamos a atualizar o nosso catálogo.<0/>Por favor, visite-nos novamente numa data posterior.",
    "nextSlide": "Seguinte",
    "prevSlide": "Anterior"
  },
  "cart": {
    "add": "Produto adicionado ao veículo",
    "fullPrice": "Preço do veículo e acessórios",
    "priceWithoutCar": "Preço dos acessórios"
  },
  "navigation": {
    "zoom": "Ampliar",
    "toggleSearch": "Alternar pesquisa",
    "cart": "Carrinho",
    "cartDelete": "Remover item do carrinho",
    "vehicle": "Veículo selecionado",
    "maxBookmarksReached": "Máximo de 15 produtos alcançados",
    "filter": {
      "toggleFilter": "Alternar filtro",
      "topProducts": "TOP Ofertas",
      "reset": "Repor filtro",
      "ready": "Feito",
      "show": "Mostrar resultados"
    },
    "searching": {
      "submit": "Enviar",
      "close": "Fechar",
      "placeholder": "Encontrar acessórios correspondentes ...",
      "suggestions": "Sugestões de pesquisa",
      "categories": "Categorias",
      "products": "Produtos",
      "productCount": "{{count}} produto",
      "productCount_other": "{{count}} produtos",
      "showAll": "Mostrar {{count}} resultado",
      "showAll_other": "Mostrar todos os {{count}} resultados",
      "expand": "Pesquisa expandida",
      "show": "Produto a mostrar",
      "found": {
        "withCategory": "Resultados da pesquisa por \"{{fuzzy}}\" na categoria \"{{category}}\"",
        "withOutCategory": "Resultados da pesquisa por \"{{fuzzy}}\" em todas as categorias"
      }
    },
    "share": "Partilhar",
    "back": "Retorno",
    "details": "Detalhes",
    "add": "Adicionar",
    "remove": "Remover",
    "close": "Fechar",
    "filtern": "Filtrar",
    "closeFilter": "Fechar filtro"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Ir para a imagem {{number}}"
    },
    "articleNumber": "Número do artigo",
    "relatedArticle": "Estes artigos também podem interessar-lhe:",
    "brand": "Marca",
    "priceBox": {
      "withVatAndMounting": "incluindo IVA e montagem",
      "withVat": "incluindo IVA",
      "recommendedRetailPrice": "Preço recomendado não vinculativo",
      "historicMinimalPurchasePrice": "Preço mais baixo nos últimos 30 dias",
      "priceDetails": "Detalhes do preço",
      "priceDetailsHeadline": "Detalhes do preço para este artigo",
      "priceToday": "Preço para este artigo hoje",
      "priceDetails30Days": "Preço mais baixo nos 30 dias anteriores à alteração de preço",
      "close": "Fechar",
      "addItem": "Adicionar artigo",
      "removeItem": "Remover artigo"
    },
    "infoBox": {
      "description": "Descrição",
      "vehicles": "Adequado para os seguintes modelos",
      "empty": "Não existem adaptações especiais de veículos para este produto.",
      "contacts": "Fabricante"
    },
    "contacts": {
      "manufacturer-contact": "Informações de contato do fabricante",
      "responsible-contact": "Pessoa responsável na UE",
      "trademark": "Marca"
    }
  },
  "productList": {
    "oemHint": "Acessórios originais para o seu {{brand}}!"
  }
}
